import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"#31344A\" fill-rule=\"evenodd\" clip-path=\"url(#i2030754872__a)\" clip-rule=\"evenodd\"><path d=\"M11 1.571a9.429 9.429 0 1 0 0 18.858A9.429 9.429 0 0 0 11 1.57ZM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11Z\"></path><path d=\"M11 6.286c.434 0 .786.351.786.785v3.638l3.802 4.43a.786.786 0 1 1-1.193 1.024l-3.991-4.651a.786.786 0 0 1-.19-.512V7.071c0-.434.352-.785.786-.785Z\"></path></g><defs><clipPath id=\"i2030754872__a\"><path fill=\"#fff\" d=\"M0 0h22v22H0z\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }